/**
 * 客服管理
 */
export default {
  csInfoselect: "/csInfo/select", // 查询
  csInfoupdate: "/csInfo/update", // 更新

  user_msgselect_store_msg_info: "/user_msg/select_store_msg_info", // 查询群发通知详情-pc
  user_msgselect_store_msg_list: "/user_msg/select_store_msg_list", // 查询群发通知列表-pc
  user_msgsend_user_list_msg: "/user_msg/send_user_list_msg", // 群发通知-pc
}
